import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/icons/transaction-successful.svg'


const _hoisted_1 = { class: "modal_content" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "modal_form" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "success_img" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1)
const _hoisted_5 = { class: "balance_amount" }
const _hoisted_6 = { class: "success__message" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h4", null, "Transaction Successful", -1)
const _hoisted_8 = { class: "modal_content_footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_CommonDialog = _resolveComponent("CommonDialog")!

  return (_openBlock(), _createBlock(_component_CommonDialog, {
    isShowHeader: false,
    isShowBackButton: false,
    className: ['money_out_success_modal'],
    width: "665px",
    height: "auto"
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_v_btn, {
            icon: "mdi-close",
            onClick: $setup.onClickCloseButton
          }, null, 8, ["onClick"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, "£" + _toDisplayString($props.balance), 1),
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("p", null, "Your money transfer to this " + _toDisplayString($props.accountNumber) + " account.", 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_v_btn, {
            class: "button button-purple-border",
            onClick: $setup.onClickCloseButton
          }, {
            default: _withCtx(() => [
              _createTextVNode("Cancel")
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_v_btn, {
            class: "button button-orange",
            onClick: $setup.onClickCloseButton
          }, {
            default: _withCtx(() => [
              _createTextVNode("Done")
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ])
    ]),
    _: 1
  }))
}